import { MDBDatatable, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { useFieldArray, useForm } from "react-hook-form";
import { getMisc } from "../../../apiclients/streamsapi_bridge";

import { getSpecificHardwareRentalProducts } from "../../../apiclients/streamsapi_bridge";

const HardwareProducts = ({
  register,
  setValue,
  getValues,
  watch,
  control,
  errors,
  reset,
  hwProductList,
  hwRentalList,
  emiProductList,
  hwEditable,
  invoice,
}) => {
  const { fields: hwField } = useFieldArray({
    control,
    name: "hw_products",
  });

  const { fields: nrcField } = useFieldArray({
    control,
    name: "emi_charge_groups",
  });

  useEffect(() => {
    const updateFormValues = () => {
      const updatedValues = {};

      if (hwProductList?.length > 0) {
        updatedValues.hw_products = hwProductList.map((assign) => ({
          ...assign,
          quantity_no: assign.quantity,
          quantity: -1,
          bgrp_id: -1,
          quantityList: Array.from({ length: assign?.quantity }, (_, i) => i + 1),
        }));
      }

      if (emiProductList?.length > 0) {
        updatedValues.emi_charge_groups = emiProductList.map((assign) => ({
          ...assign,
          totalprice: assign.price,
          price: "",
          bgrp_id: -1,
        }));
      }

      if (Object.keys(updatedValues).length > 0) {
        reset((prev) => ({
          ...prev,
          ...updatedValues,
        }));
      }
    };

    updateFormValues();
  }, [hwProductList, emiProductList, reset]);

  const location = useLocation();
  const actionData1 = {
    columns: [
      { label: "Products Name", field: "name" },
      { label: "Quantity", field: "total" },
      { label: "Net Total", field: "used" },
    ],
    rows: (hwRentalList || []).map((rlist) => {
      return {
        name: rlist?.productname || "",
        total: rlist?.quantity || "",
        used: rlist?.price || "",
      };
    }),
  };

  let processRows = [];
  (nrcField || []).forEach((info, index) => {
    processRows.push({
      nrcInfo: info,
      name: info.productName,
      price: info?.totalprice ?? "",
      assignnrc: (
        <>
          <div className="d-flex align-items-center justify-content-center">
            <MDBInput
              {...register(`emi_charge_groups.${index}.price`)}
            />
            {errors?.emi_charge_groups && errors?.emi_charge_groups[index] && errors?.emi_charge_groups[index]?.price && (
              <p className="text-danger">
                {errors?.emi_charge_groups[index]?.price?.message}
              </p>
            )}
            <select
              name=""
              id=""
              className="form-control form-select ms-3"
              value={watch(`emi_charge_groups.${index}.bgrp_id`)}
              onChange={(e) => {
                setValue(`emi_charge_groups.${index}.bgrp_id`, e.target.value, {
                  shouldDirty: true,
                });
              }}
            >
              <option value={-1}>-- Select Invoice Group --</option>
              {invoice &&
                invoice.map((loc) => (
                  <option value={parseInt(loc.billing_group_id)}>
                    {loc.group_name}
                  </option>
                ))}
            </select>
          </div>
        </>
      ),
    });
  });

  const actionData2 = {
    columns: [
      { label: "NRC Finance (Quote ID)", field: "name" },
      { label: "Price ($)", field: "price" },
      { label: "Assign NRC Price($) to Other Group", field: "assignnrc" },
    ],
    rows: processRows,
  };

  let processRowshw = [];
  (hwField || []).map((info, index) => {
    processRowshw.push({
      hwInfo: info,
      name: info.productName,
      quantity: info?.quantity_no ?? "",
      price: info?.price ?? "",
      assignto: (
        <>
          <div className="d-flex align-items-center justify-content-center">
            <select
              name=""
              id=""
              className="form-control form-select"
              value={watch(`hw_products.${index}.quantity`)}
              onChange={(e) => {
                setValue(`hw_products.${index}.quantity`, e.target.value, {
                  shouldDirty: true,
                });
              }}
            >
              <option value={-1}>-- Select Quantity --</option>
              {info?.quantityList?.map((num) => (
                <option value={num}>{num} </option>
              ))}
            </select>
            <select
              name=""
              id=""
              className="form-control form-select ms-3"
              value={watch(`hw_products.${index}.bgrp_id`)}
              onChange={(e) => {
                setValue(`hw_products.${index}.bgrp_id`, e.target.value, {
                  shouldDirty: true,
                });
              }}
            >
              <option value={-1}>-- Select Invoice Group --</option>

              {invoice &&
                invoice.map((loc) => (
                  <option value={loc.billing_group_id}>{loc.group_name}</option>
                ))}
            </select>
          </div>
        </>
      ),
    });
  });

  const actionData = {
    columns: [
      { label: "Products Name", field: "name" },
      { label: "Quantity", field: "quantity" },
      { label: "Net Total", field: "price" },
      { label: "Assign Quantity to Other Group", field: "assignto" },
    ],

    rows: processRowshw
    // (watch("hw_prod_list") || []).map((seat, index) => ({
    //   name: seat?.productName ?? "",
    //   total: seat?.quantity ?? "",
    //   used: seat?.price ?? "",
    //   unused: (
    //     <>
    //       <div className="d-flex align-items-center justify-content-center">
    //         <select name="" id="" className="form-control form-select">
    //           <option value="Credit Card" selected>
    //             -- Select Quantity --
    //           </option>

    //           {Array.from({ length: seat.quantity }, (_, idx) => idx + 1).map(
    //             (val) => (
    //               <option key={val} value={val}>
    //                 {val}
    //               </option>
    //             )
    //           )}
    //         </select>

    //         <select
    //           name=""
    //           id=""
    //           className="form-control form-select ms-3"
    //           value={watch(`available_seats.${index}.bgrp_id`)}
    //           onChange={(e) => {
    //             setValue(`available_seats.${index}.bgrp_id`, e.target.value, {
    //               shouldDirty: true,
    //             });
    //             // handleAssignSeat(e, info.serviceid)
    //           }}
    //         >
    //           <option value="Credit Card" selected>
    //             -- Select Invoice Group --
    //           </option>

    //           {invoice &&
    //             invoice.map((loc) => (
    //               <option value={loc.billing_group_id}>{loc.group_name}</option>
    //             ))}
    //         </select>
    //       </div>
    //     </>
    //   ),
    // })),
  };

  return (
    <>
      <div className="general-settings" id="general">
        Hardware, Hardware Rental & Finance
      </div>

      <div class="fw-bold" style={{ paddingLeft: '10px' }}>Hardware Products (Quote ID)</div>
      <div className="HardwareProductsDatatable">
        <MDBDatatable
          pagination={false}
          data={actionData}
          sortField="Billing Groups"
        />
      </div>

      <div class="fw-bold" style={{ paddingLeft: '10px' }}>Hardware Rental Products (Quote ID)</div>
      <div>
        <MDBDatatable
          pagination={false}
          data={actionData1}
          sortField="Billing Groups"
        />
      </div>
      <div class="fw-bold" style={{ paddingLeft: '10px' }}>NRC Finance (Quote ID)</div>
      <div>
        <MDBDatatable
          pagination={false}
          data={actionData2}
          sortField="Billing Groups"
        />
      </div>
    </>
  );
};

export default HardwareProducts;
